import React from 'react';
import { MarkdownEditor } from '../../common/markdown/MarkdownEditor';
import { ValidatingFormContext } from '../../validatingElements';

type ValidatingFormMarkdownEditorProps = {
    name: string;
    placeholder?: string | undefined;
};
export function ValidatingFormMarkdownEditor(props: ValidatingFormMarkdownEditorProps) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    <MarkdownEditor
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        value={state.item[props.name] || ''}
                        onChange={async (value) => {
                            await state.onChange(props.name, value);
                        }}
                        placeholder={props.placeholder}
                        hasTableEditor={false}
                    />
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}
